export default __webpack_public_path__ + "static/hero.dark-dc07f1f0db156b1d9a9b19b69c329ae3b1b20610e5e9698602543960203a3ec1.png";